import { render, staticRenderFns } from "./AutomaticReports.vue?vue&type=template&id=48d2dbe4&scoped=true&"
import script from "./AutomaticReports.vue?vue&type=script&lang=js&"
export * from "./AutomaticReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2dbe4",
  null
  
)

export default component.exports